import { GRAND_PRIX_ROUTE_NAMES } from '~/features/Home/constants'

export const usePageType = () => {
  const $route = useRoute()
  const isPageWithWideLpuAvatars = computed(() => Number($route.params.year) >= 2023)
  const isGrandPrixPage = computed(() =>
    !$route.name ? false : ($route.name as string).startsWith(GRAND_PRIX_ROUTE_NAMES.prefix))
  const isPageWithGrayTagline = computed(() => Number($route.params.year) >= 2023)

  return {
    isPageWithWideLpuAvatars,
    isGrandPrixPage,
    isPageWithGrayTagline,
  }
}
